import React from 'react';

const NotificationToast = ({ title, description }) => {
    return (
        <div style={{ padding: '8px' }}>
            <strong style={{ display: 'block', fontSize: '16px' }}>{title}</strong>
            <span style={{ fontSize: '14px', color: '#555' }}>{description}</span>
        </div>
    );
};

export default NotificationToast;
